import { Pipe } from '@angular/core';

import { getImgSource, type Img } from '../helpers/images.helpers';

@Pipe({
  name: 'assetsPipe',
  standalone: true,
})
export class AssetsPipe {
  public transform(img: Img): string {
    return getImgSource(img);
  }
}
